import type { PostContentTypeEnumItem } from '@ps/api/types';
import type { PostCardData } from '@ps/features/posts/post-card/PostChatMessageView';
import { PostContentType } from '@ps/models/lib/post';

import type { PostMessageContent } from '../types/ChatMessage';

/**
 * Default chat-card model from a DM post-message snapshot — the fast, always-
 * available render while `useFetchPostById` is in flight (and the fallback if it
 * fails). Mirrors PopshopRN's `defaultPost` derivation so one `PostChatMessageView`
 * serves both states (no bespoke "lite" card).
 *
 * The snapshot has no media URLs and no gate config, so the default renders
 * un-gated with a count line (from the server's `imageCount`/`videoCount`); the
 * fetched, viewer-scoped post supplies the real media + paywall.
 */
export function postCardDataFromMessageContent(
  content: PostMessageContent,
): PostCardData {
  return {
    title: content.title?.trim() || content.message?.trim() || undefined,
    description: content.description,
    // Snapshot uses the models `PostContentType`; the card wants the API enum.
    // Both share the same string values ('MEDIA_GALLERY' / 'RICH_TEXT').
    postType: (content.postType ??
      PostContentType.RichText) as unknown as PostContentTypeEnumItem,
    imageCount: content.imageCount,
    videoCount: content.videoCount,
  };
}
